module.exports = __webpack_public_path__ + "static/media/StartBlock.33c659e5.svg";